module.exports = __webpack_public_path__ + "img/playandgo.f76c929f.png";